import { Capacitor } from '@capacitor/core'
import type { ConnectionStatus } from '@capacitor/network'
import { getNetworkStatus } from './getNetworkStatus'
import { isApiReachable } from './isApiReachable'
import { makeConnectionStatus } from './makeConnectionStatus'

const REACHABILITY_TIMEOUT_MS = 4000

export const confirmNetworkStatus = async (apiUrl: string): Promise<ConnectionStatus> => {
  const status = await getNetworkStatus()

  if (status.connected || Capacitor.isNativePlatform()) return status

  if (await isApiReachable(apiUrl, REACHABILITY_TIMEOUT_MS)) return makeConnectionStatus(true)

  // the browser may have come back online while the request was running
  return getNetworkStatus()
}
